<!--门店详情-->
<template>
    <div>

    </div>
</template>

<script>

    export default {
        name: 'H5',
        components: {
        },
        data: function () {
        },
        filter: {},
        mounted() {
            console.log('this.$route.query.url',this.$route.query.url);
            if (this.$route.query.url.lastIndexOf('http') >0 ){
                let urls = this.$route.query.url.split(',')
                if(urls.length>1){
                    location.href = urls[0]
                    return ;
                }
                console.log('urls',urls);
            }
            // alert('111')
            location.href = this.$route.query.url;
        },
        destroyed() {
        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// H5.vue?0320f86a